module.exports = __webpack_public_path__ + "img/nongMin1.8d9f57dd.png";